import React from 'react';
import {Icon, Message, svgs} from 'epic-diesel-common';
import {AcceptanceStatus} from '../../../../shared/types';
import {TaxProfile} from '../components';

//@ts-ignore
import styles from '../Settings.pcss';

export interface TaxProfileSectionProps {
    rejectedInVBucks?: boolean;
    loadingAcceptance?: boolean;
    createAble?: boolean;
    acceptanceStatus: AcceptanceStatus;
}

const TaxProfileSection: React.FC<TaxProfileSectionProps> = ({
    rejectedInVBucks = false,
    loadingAcceptance = false,
    createAble = false,
    acceptanceStatus
}) => {
    if (rejectedInVBucks) {
        return null;
    }

    if (loadingAcceptance) {
        return (
            <div className={styles.loader}>
                <Icon className={styles.icon} icon={svgs.LOADING} fontSize="large" />
            </div>
        );
    }

    if (createAble) {
        //@ts-ignore
        return <TaxProfile />;
    }

    if (acceptanceStatus !== AcceptanceStatus.REJECTED) {
        return (
            <p className={styles.recordNotFound}>
                <Message code="epic.affiliate.hyperwallet.error.record.not.found" />
            </p>
        );
    }

    return null;
};

export default TaxProfileSection;
